"use client"

import {
  Flex,
  Grid,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react"

const CompanySkeleton = () => {
  return (
    <Flex flexDir="column" rowGap="18px">
      <Flex alignItems="center" columnGap="24px">
        <Skeleton h="72px" w="100%" maxW="72px" borderRadius="4px" />
        <Skeleton h="64px" w="100%" maxW="260px" borderRadius="4px" />
      </Flex>
      <Skeleton w="60%" h="24px" borderRadius="4px" />
      <Flex alignItems="center" columnGap="6px">
        <Skeleton w="100%" maxW="250px" h="30px" borderRadius="4px" />
        <Skeleton w="100%" maxW="200px" h="30px" borderRadius="4px" />
      </Flex>
      <Flex alignItems={"center"} columnGap={"12px"}>
        {Array.from(Array(5).keys()).map((skn) => (
          <SkeletonCircle key={skn} w={"30px"} h={"30px"} />
        ))}
      </Flex>

      <Skeleton w={"160px"} h={"36px"} borderRadius={"4px"} />
      <Flex flexDir={"column"} pt={"40px"} rowGap={"20px"}>
        <Flex
          flexDir={"column"}
          rowGap={"12px"}
          w={"100%"}
          maxW={"500px"}
          mb={"48px"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            columnGap={"6px"}
          >
            {Array.from(Array(4).keys()).map((skl) => (
              <Skeleton w={"100%"} h={"24px"} key={skl} />
            ))}
          </Flex>
          <Skeleton
            startColor={"borderGray"}
            endColor={"grey"}
            w={"100%"}
            h={"1px"}
          />
        </Flex>
        <SkeletonText w={"90%"} />
        <Skeleton w={"280px"} h={"12px"} />
      </Flex>
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        gap={"20px"}
        mt={"36px"}
      >
        {Array.from(Array(2).keys()).map((sk) => (
          <Skeleton
            key={sk}
            {...{ isLoaded: true }}
            w={"100%"}
            bg={"#7E869E11"}
            borderRadius={"12px"}
            pt={"20px"}
          >
            <Skeleton w={"200px"} h={"24px"} />
            <Flex flexDir={"column"} rowGap={"16px"} p={"20px"}>
              <SkeletonText w={"100%"} />
              {Array.from(Array(2).keys()).map((item) => (
                <Skeleton
                  h={"36px"}
                  w={"100%"}
                  key={item}
                  borderRadius={"4px"}
                />
              ))}
            </Flex>
          </Skeleton>
        ))}
      </Grid>
      <Skeleton w={"100%"} maxW={"260px"} h={"30px"} borderRadius={"4px"} />
      <Skeleton
        {...{ isLoaded: true }}
        w={"100%"}
        bg={"#7E869E11"}
        pt={"20px"}
        maxW={"123px"}
        p={"20px"}
        h={"fit-content"}
        borderRadius={"4px"}
      >
        <Skeleton w={"80px"} h={"80px"} />
        <Flex
          flexDir={"column"}
          alignItems={"center"}
          rowGap={"4px"}
          mt={"4px"}
        >
          <Skeleton w={"50px"} h={"10px"} />
          <Skeleton w={"60px"} h={"12px"} />
        </Flex>
      </Skeleton>
      <Skeleton w={"100%"} maxW={"200px"} h={"30px"} borderRadius={"4px"} />
      <Grid
        templateColumns={{
          base: "minmax(0, 1fr)",
          md: "repeat(3, minmax(0, 1fr))",
        }}
        gap={"36px"}
        mt={"24px"}
      >
        {Array.from(Array(6).keys()).map((sktn) => (
          <Flex flexDir={"column"} rowGap={"18px"} px={"20px"} key={sktn}>
            <SkeletonText w={"100%"} />
            <SkeletonText w={"80%"} />
          </Flex>
        ))}
      </Grid>
    </Flex>
  )
}

export default CompanySkeleton
